import { ChartCircle } from "../../Circle/ChartCircle";
import { TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import st from "@modules/dashboards/dashboardTooltips/TooltipVariants/baseTooltipStyles.module.scss";
import { formatNumber2d } from "@utils/format/number";
import { BaseElement, RowFormatter } from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/types";

export const BaseRowFormatter: RowFormatter<BaseElement> = ({ element }) => {
    return (
        <TooltipGridRow>
            <TooltipGridCell contentClassName={st['cell-content']}>
                <ChartCircle text={element.name} color={element.color} />
            </TooltipGridCell>
        </TooltipGridRow>
    )
}

type CropWithArea = BaseElement & { area: number, dimension: string }
export const RowWithAreaFormatter: RowFormatter<CropWithArea> = ({ element }) => {
    return (
        <TooltipGridRow>
            <TooltipGridCell contentClassName={st['cell-content']}>
                <ChartCircle text={element.name} color={element.color} />
            </TooltipGridCell>
            <TooltipGridCell align={'end'}>
                { formatNumber2d(element.area) + ' ' + element.dimension }
            </TooltipGridCell>
        </TooltipGridRow>
    )
}